import React from 'react';
import { useClinic } from '@/contexts/ClinicContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2 } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';

const ClinicSwitcher: React.FC = () => {
  const { currentClinic, clinics, setCurrentClinic, isLoading } = useClinic();

  if (isLoading) {
    return <Skeleton className="h-8 w-40" />;
  }

  if (!currentClinic) {
    return null;
  }

  return (
    <div className="flex items-center">
      <Select
        value={currentClinic.id}
        onValueChange={(value) => {
          const clinic = clinics.find(c => c.id === value);
          if (clinic) {
            setCurrentClinic(clinic);
          }
        }}
      >
        <SelectTrigger className="w-40 h-8 bg-gray-50 border-gray-200 hover:bg-gray-100 transition-colors">
          <div className="flex items-center gap-1.5 overflow-hidden">
            <Building2 className="h-4 w-4 text-primary flex-shrink-0" />
            <span className="truncate text-sm">
              <SelectValue placeholder="Select clinic" />
            </span>
          </div>
        </SelectTrigger>
        <SelectContent>
          {clinics.map((clinic) => (
            <SelectItem 
              key={clinic.id} 
              value={clinic.id}
              className="text-sm"
            >
              <span className="truncate">{clinic.name}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default ClinicSwitcher;